import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

import MenuItem from "@mui/material/MenuItem";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_From_MongoDB";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import GetClientAddress from "../../../../functions/GetClientAddress";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

const ViewEC = () => {
  const { id, Agencyid } = useParams();
  const { logout } = StaffuseAuth();

  const [EC, setEC] = useState({
    _id: id,
    BasicInfo: {
      First_Name: "",
      Last_Name: "",
      Email: "",
      Number: "",
      Commision: "20%",
      Job_Title: "",
      Social_Media_Contact: "",
    },
    MetaData: {
      Agency_id: Agencyid,
      Password: "",
    },
  });

  useEffect(() => {
    if (id !== "AddEC") {
      Get_One_From_MongoDB("IP", "EC", id, setEC, logout);
    }
  }, []);

  const [Agency, setAgency] = useState({ BasicInfo: {}, MetaData: {} });

  useEffect(() => {
    Get_One_From_MongoDB("IP", "Agencies", Agencyid, setAgency, logout);
  }, []);

  //This is the state for the update progress
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleAddEC(e) {
    e.preventDefault();
    let data = EC;
    delete data._id;
    Post_To_MongoDB(data, "IP", "EC", setIsSubmitting, logout);
  }

  function handleBasicUpdate(e) {
    e.preventDefault();
    let data = EC;
    delete data._id;
    Update_To_MongoDB_By_ID(data, "IP", "EC", setIsSubmitting, id, logout);
  }

  function handleChange(e) {
    e.preventDefault();
    setEC({ ...EC, [e.target.name]: e.target.value });
  }

  // Functions for handling changes in BasicInfo and OrderInfo
  const handleBasicInfoChange = (e) => {
    setEC({
      ...EC,
      BasicInfo: { ...EC.BasicInfo, [e.target.name]: e.target.value },
    });
  };

  // Functions for handling changes in BasicInfo and OrderInfo
  const handleMetaDataChange = (e) => {
    setEC({
      ...EC,
      MetaData: { ...EC.MetaData, [e.target.name]: e.target.value },
    });
  };

  const handleCopyBookNowForm = () => {
    const textToCopy = GetClientAddress() + `Public/RegistrationForm/${EC._id}`;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {})
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const handleCopyLoginPortal = () => {
    const textToCopy =
      GetClientAddress() +
      `Consultant/login/${EC.BasicInfo?.Email}/${EC.MetaData?.Password}`;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {})
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };
  //---------------------------------Components---------------------------------
  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <h1 style={{ marginTop: "0px" }}>
        View EC:{" "}
        {EC.BasicInfo && EC.BasicInfo.First_Name ? EC.BasicInfo.First_Name : ""}
      </h1>
      <br></br>
      {id === "AddEC" ? (
        <></>
      ) : (
        <h4 style={{ marginTop: "0px" }}>
          Personal Registration Form Link:
          <br></br>
          {GetClientAddress()}Public/RegistrationForm/{EC._id}
          <br></br>
          <button onClick={handleCopyBookNowForm} style={{ maxWidth: "5%" }}>
            Copy form
          </button>
          <Link
            //to={GetClientAddress()Public/RegistrationForm/{EC._id}
            to={`${GetClientAddress()}Public/RegistrationForm/${EC._id}`}
          >
            <button style={{ textDecoration: "none", maxWidth: "5%" }}>
              Go To Form
            </button>
          </Link>
          <br></br>
          <br></br>
          Portal Link:
          <br></br>
          {GetClientAddress()}Consultant/login/{EC.BasicInfo?.Email}/
          {EC.MetaData?.Password}
          <br></br>
          <button onClick={handleCopyLoginPortal} style={{ maxWidth: "5%" }}>
            Copy Link
          </button>
          <Link
            //to={GetClientAddress()Public/RegistrationForm/{EC._id}
            to={`${GetClientAddress()}Consultant/login/${EC.BasicInfo?.Email}/${
              EC.MetaData?.Password
            }`}
          >
            <button style={{ textDecoration: "none", maxWidth: "5%" }}>
              Go To Portal
            </button>
          </Link>
        </h4>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <section>
            <h2>Basic Info</h2>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  key="_id"
                  name="_id"
                  label="_id"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC["_id"]}
                  onChange={(e) => handleChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled
                />
                <TextField
                  key="Agency_id"
                  name="Agency_id"
                  label="Agency_id"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.MetaData["Agency_id"]}
                  onChange={(e) => handleMetaDataChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled
                />
                <TextField
                  key="Agency_Name"
                  name="Agency_Name"
                  label="Agency Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={Agency.BasicInfo["Name"]}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true, // This will keep the label above the input field
                  }}
                  disabled
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="First_Name"
                  name="First_Name"
                  label="First_Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.BasicInfo["First_Name"]}
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Last_Name"
                  name="Last_Name"
                  label="Last_Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.BasicInfo["Last_Name"]}
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Job_Title"
                  name="Job_Title"
                  label="Job_Title"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    EC.BasicInfo && EC.BasicInfo["Job_Title"]
                      ? EC.BasicInfo["Job_Title"]
                      : ""
                  }
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />{" "}
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="Email"
                  name="Email"
                  label="Email"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.BasicInfo["Email"]}
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Number"
                  name="Number"
                  label="Number"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.BasicInfo["Number"]}
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />{" "}
                <TextField
                  key="Social_Media_Contact"
                  name="Social_Media_Contact"
                  label="Social Media Contact"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.BasicInfo["Social_Media_Contact"]}
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />{" "}
              </Grid>
              <Grid item xs={3}>
                <TextField
                  key="Commision"
                  name="Commision"
                  label="Commision"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.BasicInfo["Commision"]}
                  onChange={(e) => handleBasicInfoChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Password"
                  name="Password"
                  label="Password"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.MetaData["Password"]}
                  onChange={(e) => handleMetaDataChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
                <TextField
                  key="Admin"
                  name="Admin"
                  label="Admin"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={EC.MetaData?.Admin || ""}
                  onChange={(e) => handleMetaDataChange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  select
                >
                  <MenuItem key={""} value={""}></MenuItem>

                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </section>
        </Grid>
      </Grid>
      {/* Handle Arrays */}
      <h1>Actions</h1>
      <Button
        type="submit"
        variant="contained"
        sx={{ mt: 3, ml: 1 }}
        disabled={isSubmitting}
        onClick={(e) =>
          id === "AddEC" ? handleAddEC(e) : handleBasicUpdate(e)
        }
      >
        {isSubmitting
          ? "Submitting..."
          : id === "AddEC"
          ? "Add EC"
          : "Update EC"}
      </Button>
    </div>
  );
};

export default ViewEC;
